import GlobalConstants from "@/store/constants/global"
export default {
  name: "App",
  components: {},
  async created() {
    this.$store.dispatch(GlobalConstants.DISPATCH.initApp);
  }
};
